<template>
  <transition name="fade-tran">
    <div class="ui-bottom-picker" @click.stop.self="handleClose" v-show="value">
      <div class="content">
        <div class="title">{{ title }}</div>
        <NfPicker
          :dataList="dataList"
          :ref="`bottemPicker_${pcikerKey}`"
          :cellH="pickerOptions.cellH"
          :cellCount="pickerOptions.cellCount"
          :labelKey="labelKey"
        />
        <div class="btn-wrapper" :style="{ paddingBottom: systemInfo.isPhoneX ? '34px' : '' }">
          <button class="btn btn-cancel" @click.stop="handleCancel">取消</button>
          <button class="btn btn-confirm" @click.stop="handleConfirm">确定</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import NfPicker from "@/components/NfPicker"
import remToPx from "@/utils/remToPx"
import { mapGetters } from "vuex"

export default {
  name: "uiBottomPicker",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "请选择"
    },
    dataList: {
      type: Array,
      default() {
        return []
      }
    },
    height: {
      type: String,
      default: ""
    },
    pcikerKey: {
      type: String,
      default: window.Math.random()
        .toString(36)
        .substring(2)
    },
    labelKey: {
      type: String,
      default: "name"
    },
    mountElClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pickerOptions: {
        cellH: remToPx(1),
        cellCount: 4
      }
    }
  },
  methods: {
    handleGetSelArr() {
      const key = `bottemPicker_${this.pcikerKey}`
      return this.$refs[key].selArr.slice(0)
    },
    handleGetSelItem() {
      const key = `bottemPicker_${this.pcikerKey}`
      return this.$refs[key].selItem.slice(0)
    },
    handleClose() {
      this.$emit("input", false)
    },
    handleCancel() {
      this.handleClose()
      this.$emit("cancel")
    },
    handleConfirm() {
      const selArr = this.handleGetSelArr()
      const selItem = this.handleGetSelItem()
      this.$emit("confirm", { selArr, selItem })
      this.handleClose()
    },
    mountPicker() {
      if (this.mountElClass) {
        document.querySelector(`.${this.mountElClass}`).appendChild(this.$mount().$el)
      }
    }
  },
  components: {
    NfPicker
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo"
    })
  },
  mounted() {
    this.mountPicker()
    // document.body.appendChild(this.$mount().$el)
  }
}
</script>

<style lang="scss" scoped>
.ui-bottom-picker {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column-reverse;
  .content {
    background: #ffffff;
    width: 100%;
    transform-origin: 50% 0;
    border-radius: 0.2rem 0.2rem 0 0;
    overflow: hidden;
    .title {
      font-family: PingFangSC-Regular;
      font-size: 0.34rem;
      color: #999999;
      height: 1.08rem;
      background: #f7f7f7;
      text-align: center;
      line-height: 1.08rem;
    }
    .btn-wrapper {
      border-top: 1px solid #dddddd;
      display: flex;
      .btn {
        background: #ffffff;
        outline: none;
        border: none;
        height: 0.96rem;
        flex: 1;
        position: relative;
        &::after {
          content: "";
          display: block;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate3d(0, -50%, 0);
          height: 0.48rem;
          border-right: 1px solid #dddddd;
        }
        &:last-child {
          border-right: none;
          &::after {
            display: none;
          }
        }
        &.btn-cancel {
          font-family: PingFangSC-Regular;
          font-size: 0.34rem;
          color: #389bee;
          letter-spacing: 0;
          text-align: center;
        }
        &:active {
          opacity: 0.7;
        }
        &.btn-confirm {
          font-family: PingFangSC-Regular;
          font-size: 0.34rem;
          color: #389bee;
          letter-spacing: 0;
          text-align: center;
        }
      }
    }
  }
}
.fade-tran-enter,
.fade-tran-leave-to {
  opacity: 0;
  .content {
    transform: translate3d(0, 100%, 0);
  }
}
.fade-tran-enter-to,
.fade-tran-leave {
  opacity: 1;
  .content {
    transform: translate3d(0, 0, 0);
  }
}
.fade-tran-enter-active,
.fade-tran-leave-active {
  transition: all 0.3s ease-in-out;
  .content {
    transition: all 0.3s ease-in-out;
  }
}
</style>
